import { render, staticRenderFns } from "./league-data-crawler.vue?vue&type=template&id=226bd42a&scoped=true"
import script from "./league-data-crawler.vue?vue&type=script&lang=js"
export * from "./league-data-crawler.vue?vue&type=script&lang=js"
import style0 from "./league-data-crawler.vue?vue&type=style&index=0&id=226bd42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bd42a",
  null
  
)

export default component.exports